import Rete from 'rete';

import Timer from './Timer';
import { TIMER_INPUT_SOCKET, TIMER_OUTPUT_SOCKET } from '../SOCKETS';
import trackNodeHistory from '../utils/history/trackNodeHistory';

class TimerComponent extends Rete.Component {
  constructor(emitter) {
    super('Timer');
    this.render = 'vue';
    this.data.component = Timer;
    this.data.props = {};
    this.emitter = emitter;
  }

  builder = node => {
    const input = new Rete.Input('inputs', '', TIMER_INPUT_SOCKET, true);
    const output = new Rete.Output('targets', 'Then', TIMER_OUTPUT_SOCKET);

    node.addInput(input);
    node.addOutput(output);
    trackNodeHistory(this, node, this.emitter);
  };
}

export default TimerComponent;
